<template>
	<el-date-picker
		ref="input"
		class="input-sigarus-date-picker"
		type="date"
		v-model="model"
		v-bind="{...$attrs, ...$props}"
		:clearable="false"
		value-format="dd/MM/yyyy"
		:picker-options="{firstDayOfWeek: 1}"
		@focus="$emit('focus')"
		@blur="$emit('blur')"
	/>
</template>

<script>
import moment from 'moment'
	export default {
		name: 'InputSigarusDatePicker',
		props: {
			value: {
				default: ''
			},
			format: {
				type: String,
				default: 'dd/MM/yyyy'
			},
			valueFormat: {
				type: String,
				default: 'dd/MM/yyyy'
			}
		},
		computed: {

			model: {

				get () {
					return this.value
				},

				set (val) { 
					this.$emit('input', val) 
					this.$emit('save', val)
				}

			}

		},
		methods: {

			focus () { setTimeout(() => this.$refs.input.focus(), 200) },

			select () { setTimeout(() => this.$refs.input.$children[0].$refs.input.select(), 200) }

		}
	}
</script>

<style>
.el-input__prefix {
	display: none;
}
</style>
